import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { type ITabItem, Tabs } from 'shared/ui'
import { type BillingPeriod } from 'pages/settings/ui/BillingPlan'
import styles from './styles.module.scss'

type ITimePeriodTabsProps = {
  period: BillingPeriod
  className?: string
  handleSetPeriod: (tab: ITabItem<BillingPeriod>) => void
}

export const TimePeriodTabs = observer(
  ({ period, className, handleSetPeriod }: ITimePeriodTabsProps) => {
    const periodTabs: ITabItem<BillingPeriod>[] = [
      { name: 'Monthly', key: 'monthly' },
      {
        name: 'Annually',
        key: 'annually',
        statusProps: {
          title: 'Get 2 months FREE',
          emphasis: 'high',
          intent: 'positive',
          size: 'small',
        },
      },
    ]
    return (
      <Tabs
        variant='simpleWithoutBorder'
        tabs={periodTabs}
        activeTabKey={period}
        handleSelectTab={handleSetPeriod}
        tabsClassName={classNames(styles.tabs, className)}
      />
    )
  }
)
